import { createApi } from "@reduxjs/toolkit/query/react"
import { NotificationResponseDto, NotificationSeenRequestPayload, PushSubscriptionData } from "types/notification.types"
import { RootState } from "appRedux/store"
import { baseQueryWithMiddlewares } from "appRedux/baseQuery"
import { updateNotifications, updateUnseenNotificationsCount, updateNotificationsHasMore } from "appRedux/slices/notificationSlice"
import { handleOnSubscribePushNotificationQueryStarted } from "appRedux/helpers/notificationApiHelpers"

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: baseQueryWithMiddlewares("/notification"),
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationResponseDto, number>({
      query: (page) => page > 1 ? `?page=${page}` : "",
      onQueryStarted: async (page, { dispatch, queryFulfilled, getState }) => {
        try {
          const { data } = await queryFulfilled
          const state = getState() as RootState
          const prevNotifs = state.notification.notifications
          if (page > 1) {
            dispatch(updateNotifications([...prevNotifs, ...data.notifications]))
          } else {
            dispatch(updateNotifications(data.notifications))
          }
          dispatch(updateNotificationsHasMore(data.hasMore))
        } catch (error) {
          console.error("Error getting notifications:", error)
        }
      }
    }),
    seenNotification: builder.mutation<void, NotificationSeenRequestPayload>({
      query: (body) => ({
        url: "/seen",
        method: "POST",
        body: body
      })
    }),
    getNotificationsCount: builder.query<number, void>({
      query: () => "/count",
      onQueryStarted: async (arg, { dispatch, queryFulfilled, getState }) => {
        try {
          const { data } = await queryFulfilled
          dispatch(updateUnseenNotificationsCount(data))
        } catch (error) {
          console.error("Error getting notifications count:", error)
        }
      }
    }),
    subscribePushNotification: builder.mutation<void, PushSubscriptionData>({
      query: (subscriptionData) => ({
        url: "/push/subscribe",
        method: "POST",
        body: subscriptionData
      }),
      onQueryStarted: handleOnSubscribePushNotificationQueryStarted
    })
  })
})

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useSeenNotificationMutation,
  useGetNotificationsCountQuery,
  useSubscribePushNotificationMutation
} = notificationApi
